import { useContext } from 'react';
import bem from '../../../../utils/bem';

import StarRating from '../../StarRating';
import Tag from '../../../Atoms/Tag';
import CheckboxButton from '../../../Atoms/FormComponents/CheckboxButton';
import ItemMetaData from '../../../Atoms/ItemMetaData';
import ContactsBlock from '../../ContactBlock';
import Credentials from '../../Credentials';
import DropDown from '../../DropDown';
import CtaLink from '../../../Atoms/CtaLink';
import Icon from '../../../Atoms/Icon/Icon';
import RemoveContractorModal from './removeContractorModal';
import ResponsiveImage from '../../../Atoms/ResponsiveImage';
import { FapAppContext } from '../../../../context/fap-app.context';
import { makeFullUrl } from '../../../../utils/analitic.utils';
import {
  openModalHandler,
  closeModalHandler,
} from '../../../../utils/handleModalActions';

const ContractorCard = ({
  contractorData,
  isSmall,
  showCheckBox,
  showRemove,
  onRemove,
  onAdd,
  className,
  showProfileBtn,
  showDefaultImage,
  isButtonDisabled,
  isSelected,
  checkBockTooltip,
  analytics,
}) => {
  const { addToEstimateAnalytics } = useContext(FapAppContext);
  const baseCSSClass = 'm-contractor-card';
  const {
    id,
    title,
    url,
    image,
    rating,
    tag,
    meta,
    contacts,
    contactsTitle = 'Contacts',
    services,
    servicesTitle,
    credentials,
    hideButtonText = 'Hide Details',
    openButtonText = 'View Details',
    cta = {
      fieldCta: [{ title: Drupal.t('View Full Profile'), url }],
    },
  } = contractorData;
  const componentClasses = bem(baseCSSClass, [isSmall && 'small'], '', [
    className,
  ]);
  const ratingTipText = Drupal.t(
    'Customers with extended warranties have provided ratings.',
  );

  const onRemoveHandler = () => onRemove(id);

  const onAddHandler = () => onAdd(id);

  const onCheckUncheckHandler = (v) => {
    if (v) {
      onAddHandler();
      addToEstimateAnalytics(title, 'find_a_pro_listing');
    } else {
      onRemoveHandler();
    }
  };

  const openModal = (e) => openModalHandler(e, 'contractor-remove-opened');

  const closeModal = (e) => closeModalHandler(e, 'contractor-remove-opened');

  const ctaAnalyticData = {
    event: 'find_a_pro_profile_clicked',
    event_origin: 'front_end',
    vendor_name: contractorData.title,
    product_category: contractorData.contacts.analytics?.productCategory?.label,
    zip_code: contractorData.contacts.analytics?.zip,
    link_url: makeFullUrl(contractorData.url),
    content_type: 'find_a_pro_thank_you',
  };

  const Details = () => (
    <DropDown>
      <DropDown.Toggle
        closedText={Drupal.t(openButtonText)}
        openedText={Drupal.t(hideButtonText)}
        onOpenAnalytics={
          analytics?.vendorDetailsExpandedAnalytics
            ? {
                ...analytics.vendorDetailsExpandedAnalytics,
                vendor_name: title,
              }
            : null
        }
      />
      <DropDown.Content>
        <div className={bem('details', [], baseCSSClass)}>
          <div className={bem('contacts', [], baseCSSClass)}>
            {contacts && (
              <ContactsBlock
                {...contacts}
                title={Drupal.t(contactsTitle)}
                cta={cta}
              />
            )}
          </div>
          <div className={bem('info', [], baseCSSClass)}>
            {services && (
              <div className={bem('services', [], baseCSSClass)}>
                <p className="h h6">
                  {servicesTitle
                    ? Drupal.t(servicesTitle)
                    : Drupal.t('Services')}
                </p>
                <ul className={bem('services-list', [], baseCSSClass)}>
                  {services.map((s, i) => (
                    <li
                      key={s + i}
                      className={bem('services-item', [], baseCSSClass)}
                    >
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {credentials && (
              <div>
                <Credentials {...credentials} />
              </div>
            )}
          </div>
          {cta && (
            <CtaLink
              {...cta}
              mods={['primary', 's']}
              extra={`${baseCSSClass}__more-link`}
            />
          )}
        </div>
      </DropDown.Content>
    </DropDown>
  );

  return (
    <div className={componentClasses}>
      <div className={bem('summary', [], baseCSSClass)}>
        {showRemove && (
          <div className={bem('remove-wrap', [], baseCSSClass)}>
            <button
              type="button"
              data-modal-id={`modal__remove-contractor--${id}`}
              className={bem('remove-btn', [], baseCSSClass, ['js-modal-open'])}
              onClick={(e) => openModal(e)}
            >
              {Drupal.t('Remove')}
              <Icon iconName="close-small" width={14} height={14} />
            </button>
            <RemoveContractorModal
              onRemoveHandler={() => onRemoveHandler(id)}
              title={title}
              modalId={`modal__remove-contractor--${id}`}
              onCloseHandler={closeModal}
              onCancelHandler={closeModal}
            />
          </div>
        )}
        {rating && (
          <StarRating
            {...rating}
            tipText={ratingTipText}
            className={bem('rating', [], baseCSSClass)}
            srId={`stars-${id}${isSmall ? '-small' : ''}`}
          />
        )}

        {(showDefaultImage || image) && (
          <div className={bem('image', [], baseCSSClass)}>
            {showDefaultImage && !image && <Icon iconName="contractor-man" />}
            {image && <ResponsiveImage {...image} />}
          </div>
        )}

        {title && (
          <p className={bem('title', [], baseCSSClass, ['h', 'h6'])}>{title}</p>
        )}

        {tag && (
          <p className={bem('tag', [], baseCSSClass)}>
            <Tag {...tag} />
          </p>
        )}

        {meta && (
          <div className={bem('meta', [], baseCSSClass)}>
            <ItemMetaData items={meta} />
          </div>
        )}

        {showCheckBox && (
          <div className={bem('check-btn', [], baseCSSClass)}>
            <CheckboxButton
              id={`add-to-compare-${id}`}
              onChange={(v) => onCheckUncheckHandler(v)}
              disabled={!isSelected && isButtonDisabled}
              isSelected={!!isSelected}
              tooltip={checkBockTooltip}
              withoutBorder={true}
            />
          </div>
        )}
        {isSmall && showProfileBtn && (
          <CtaLink
            {...cta}
            mods={['primary', 's']}
            extra={[
              `${baseCSSClass}__more-link`,
              `${baseCSSClass}__more-link--in-small`,
            ]}
            onClickAnalyticData={ctaAnalyticData}
          />
        )}
      </div>
      {!isSmall && <Details />}
    </div>
  );
};

export default ContractorCard;
